/**
 * GitLab.com package registry for DataPlatform @oneplatform web components.
 * Project: https://gitlab.com/aceve/oneplatform/webcomponents
 */

export const DATAPLATFORM_GITLAB_PROJECT_URL =
  'https://gitlab.com/aceve/oneplatform/webcomponents';

export const DATAPLATFORM_GITLAB_PACKAGES_URL =
  'https://gitlab.com/aceve/oneplatform/webcomponents/-/packages';

/** Path-encoded project path used in GitLab Package Registry API URLs */
export const DATAPLATFORM_GITLAB_PROJECT_PATH = 'aceve%2Foneplatform%2Fwebcomponents';

export const DATAPLATFORM_NPM_REGISTRY =
  `https://gitlab.com/api/v4/projects/${DATAPLATFORM_GITLAB_PROJECT_PATH}/packages/npm/`;

/**
 * Canonical .npmrc contents for installing DataPlatform @oneplatform packages.
 * Replace YOUR_GITLAB_TOKEN with a PAT that has read_api (or use ${NPM_TOKEN}).
 */
export const DATAPLATFORM_NPMRC = `@oneplatform:registry=${DATAPLATFORM_NPM_REGISTRY}
//gitlab.com/api/v4/projects/${DATAPLATFORM_GITLAB_PROJECT_PATH}/packages/npm/:_authToken=YOUR_GITLAB_TOKEN`;

/**
 * Bash snippet to create .npmrc and install DataPlatform packages.
 * @param {string[]} [packageNames]
 * @returns {string}
 */
export const generateDataPlatformInstallBash = (
  packageNames = [
    '@oneplatform/collector-services-wc-standalone',
    '@oneplatform/supplier-services-wc-standalone',
    '@oneplatform/document-builder-wc-standalone',
    '@oneplatform/document-flow-services-wc-standalone',
    '@oneplatform/document-format-converter-wc-standalone',
  ]
) => {
  const installs = packageNames.map((name) => `npm install ${name}`).join('\n');
  return `# Configure .npmrc (GitLab.com DataPlatform registry)
# Project: ${DATAPLATFORM_GITLAB_PROJECT_URL}
echo "@oneplatform:registry=${DATAPLATFORM_NPM_REGISTRY}" > .npmrc
echo "//gitlab.com/api/v4/projects/${DATAPLATFORM_GITLAB_PROJECT_PATH}/packages/npm/:_authToken=YOUR_GITLAB_TOKEN" >> .npmrc

# Install packages
${installs}`;
};
